import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import PhotographLayout from "views/layout/PhotographLayout";
const PhotographHome = Loadable(lazy(() => import("views/public/photograph")));
const PhotographContact = Loadable(
  lazy(() => import("views/public/photograph/Contact"))
);
const PublicAlbum = Loadable(lazy(() => import("views/public/PublicAlbum")));

const PhotographPublicRoutes = {
  path: "/photographs",
  element: <PhotographLayout />,
  children: [
    {
      path: "/photographs/:photograph_id",
      element: <PhotographHome />,
    },
    {
      path: "/photographs/:photograph_id/contact",
      element: <PhotographContact />,
    },
    {
      path: "/photographs/:photograph_id/albums/:id",
      element: <PublicAlbum tab="" />,
    },
    {
      path: "/photographs/:photograph_id/albums/:id/photos",
      element: <PublicAlbum tab="photos" />,
    },
    {
      path: "/photographs/:photograph_id/albums/:id/athletes",
      element: <PublicAlbum tab="athletes" />,
    },
    {
      path: "/photographs/:photograph_id/albums/:id/prices",
      element: <PublicAlbum tab="prices" />,
    },
    {
      path: "/photographs/:photograph_id/albums/:id/selfie",
      element: <PublicAlbum tab="selfie" />,
    },
  ],
};

export default PhotographPublicRoutes;
